function hasDescription(description) {
  return typeof description === "string" && description.trim().length > 0;
}

export default hasDescription;
